import CharterAuditLogsView from '@/charter/CharterAuditLogs.vue';
import CharterCrewBriefingView from '@/charter/CharterCrewBriefingView.vue';
import CharterCrewBriefingFormView from '@/charter/CharterCrewBriefingFormView.vue';
import CharterDailyDeparturesView from '@/charter/CharterDailyDepartures.vue';
import CharterFinancialReportView from '@/charter/CharterFinancialView.vue';
import CharterChangesView from '@/charter/CharterFlightChanges.vue';
import CharterFlightsOverviewView from '@/charter/CharterFlightsOverview.vue';
import CharterIndexView from '@/charter/CharterIndexView.vue';
import CharterMasterDataView from '@/charter/CharterMasterDataView.vue';
import CharterUsersView from '@/charter/CharterUsersView.vue';
import { RouteRecordRaw } from 'vue-router';
import { meta, route } from '@/router/router-helpers.ts';

const CHARTER_APP_ID = 'charter' as const;
const charterMeta = (title: string) => meta({
  app: CHARTER_APP_ID,
  charterAccessRequired: true,
  title,
});

const charterRoutes: RouteRecordRaw[] = [
  route('charter', CharterIndexView, {
    path: '/charter',
    meta: charterMeta('Charter'),
    redirect: { name: 'charter-flights-overview' },
    children: [
      route('charter-flights-overview', CharterFlightsOverviewView, {
        path: 'flights-overview',
        meta: charterMeta('Flights Overview'),
      }),
      route('charter-flight-crew-briefing', CharterCrewBriefingFormView, {
        path: 'flights-overview/:charterId/crew-briefing',
        meta: charterMeta('Crew Briefing'),
      }),
      route('charter-changes', CharterChangesView, {
        path: 'changes',
        meta: charterMeta('Changes'),
      }),
      route('charter-daily-departures', CharterDailyDeparturesView, {
        path: 'daily-departures',
        meta: charterMeta('Daily Departures'),
      }),
      route('charter-audit-logs', CharterAuditLogsView, {
        path: 'audit-logs',
        meta: charterMeta('Audit Logs'),
      }),
      route('charter-crew-briefing', CharterCrewBriefingView, {
        path: 'crew-briefing',
        meta: charterMeta('Crew Briefing'),
      }),
      route('charter-master-data', CharterMasterDataView, {
        path: 'master-data',
        meta: charterMeta('Master Data'),
      }),
      route('charter-users', CharterUsersView, {
        path: 'users',
        meta: charterMeta('Users'),
      }),
      route('charter-financial-report', CharterFinancialReportView, {
        path: 'financial-report',
        meta: charterMeta('Financial Report'),
      }),
    ],
  }),
];

export default charterRoutes;
